// Pro's Settings tabs that are other areas' pages: the Account page's Profile, Appearance and
// Achievements and Settings' Access tokens, drawn in Pro's Settings (spec
// ui-perf/ui-switch-classic-simple-pro, PR e5a; Achievements, spec ui-perf/pro-studio-redesign,
// decision 35). Composed here: a feature never imports another; the composition root may.
import { createRoute, useParams } from "@tanstack/react-router";

import { Profile } from "../features/account/ProfileScreen";
import { Achievements } from "../features/achievements/AchievementsScreen";
import { Appearance } from "../features/appearance/AppearanceScreen";
import { studio2Route } from "../features/studio2/routes";
import { ProSettingsFrame } from "../features/studio2/settings/SettingsPage";
import { AccessTokens } from "../features/tokens/TokensScreen";

const P = "/signed-in/teams/$teamId/brands/$brandId/studio/pro/settings";

/** `pro/settings/account`: the Account page's Profile. */
export const studio2AccountRoute = createRoute({
  getParentRoute: () => studio2Route,
  path: "settings/account",
  component: function ProAccount() {
    const { teamId, brandId } = useParams({ from: `${P}/account` });
    return (
      <ProSettingsFrame teamId={teamId} brandId={brandId} narrow>
        <Profile />
      </ProSettingsFrame>
    );
  },
});

/** `pro/settings/appearance`: the Account page's Appearance, the person's theme. */
export const studio2AppearanceRoute = createRoute({
  getParentRoute: () => studio2Route,
  path: "settings/appearance",
  component: function ProAppearance() {
    const { teamId, brandId } = useParams({ from: `${P}/appearance` });
    return (
      <ProSettingsFrame teamId={teamId} brandId={brandId} narrow>
        <Appearance teamId={teamId} />
      </ProSettingsFrame>
    );
  },
});

/** `pro/settings/achievements`: the Account page's Achievements, the person's board. */
export const studio2AchievementsRoute = createRoute({
  getParentRoute: () => studio2Route,
  path: "settings/achievements",
  component: function ProAchievements() {
    const { teamId, brandId } = useParams({ from: `${P}/achievements` });
    return (
      <ProSettingsFrame teamId={teamId} brandId={brandId} narrow>
        <Achievements />
      </ProSettingsFrame>
    );
  },
});

/** `pro/settings/tokens`: Settings' Access tokens, the team's in the URL. */
export const studio2TokensRoute = createRoute({
  getParentRoute: () => studio2Route,
  path: "settings/tokens",
  component: function ProTokens() {
    const { teamId, brandId } = useParams({ from: `${P}/tokens` });
    return (
      <ProSettingsFrame teamId={teamId} brandId={brandId}>
        <AccessTokens teamId={teamId} titleOrder={2} />
      </ProSettingsFrame>
    );
  },
});
